<template>
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">高端总经销材料计划</h3>

    <div class="form-container">
      <div class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
      </div>
      <el-form
        ref="form"
        disabled
        inline
        size="mini"
        label-width="100px"
        :model="conditions"
        :show-message="false"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="材料计划编号">
              <el-input
                v-model="conditions.packpl_id"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="packpl_type" label="单据类型">
              <el-input value="高端总经销材料计划" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer" label="订单客户">
              <el-input
                v-model="conditions.customer"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select
                v-model="conditions.custypenumber"
                type="select"
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.name1"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-select
                v-model="conditions.zzfld00001h"
                type="select"
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="包材备用金">
              <el-input v-model="conditions.tby_dmbtr" />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="预约">
              <el-checkbox v-model="conditions.preorder" true-label="1" false-label="0" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 2 }"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.uname"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="部门">
              <el-input
                v-model="conditions.dept_name"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.datum"
                value-format="yyyyMMdd"
                type="date"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据状态">
              <el-input
                v-model="conditions.status"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="材料计划明细" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #filename="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.filename }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('history')">
        <vxe-grid
          ref="history"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>

    </div>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import {
  apiGetMaterialPlanDetail
} from '@/api/sap/material-plan'
import { sapDownloadFile } from '@/utils/frontExport'

export default {
  data() {
    return {
      conditions: {
        id: '',
        packpl_id: '', // 单据编号
        packpl_type: 'ZM03', // 单据类型
        customer: '', // 客户编号
        custypenumber: '', // 客户类型
        name1: '', // 客户名称
        zzfld00001h: '', // 营销单元
        uname: '', // 创建人
        datum: '', // 创建时间
        status: '新建', // 单据状态
        preorder: '0', // 是否预约
        dept_name: ''
      },
      selectDataOptions: {},
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { field: 'packpl_item', title: '行号', width: 50, formatter: ({ cellValue }) => Number(cellValue) },
          { field: 'product_id', title: '产品编码', width: 200, slots: { default: 'product_id' }, editRender: {}, params: { bgEdit: true }},
          { field: 'description', title: '产品描述' },
          { field: 'wlybrand', title: '品牌' },
          { field: 'planqty_box', title: '计划数量（箱）', slots: { default: 'planqty_box' }, editRender: {}, params: { bgEdit: true }},
          { field: 'planqty_bottle', title: '计划数量（盒）', slots: { default: 'planqty_bottle' }, params: { bgEdit: true }},
          { field: 'planqty_ton', title: '计划数量（吨）' },
          { field: 'by_dmbtr', title: '包材保证金', width: 80 },
          { field: 'status', title: '状态', width: 80 },
          { field: 'remark', title: '备注', slots: { default: 'remark' }, params: { bgEdit: true }}
        ],
        data: [],
        delData: []
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { field: 'filename', title: '附件名', width: 'auto', slots: { default: 'filename' }},
          { field: 'doc_type', title: '附件类型', width: 'auto' },
          { field: 'filelength', title: '附件大小', width: 'auto' },
          { field: 'zzfld00002d', title: '上传人', width: 'auto' },
          { field: 'zzfld00002d_dscr', title: '上传人姓名', width: 'auto' },
          { field: 'created_date', title: '上传日期', width: 'auto' },
          { field: 'created_time', title: '上传时间', width: 'auto' }
        ],
        data: [],
        delData: []
      },
      gridOptionsHistory: {
        columns: [
          { field: 'operationer', title: '操作员', width: 'auto' },
          { field: 'oper_name', title: '操作员姓名', width: 'auto' },
          { field: 'changin_date', title: '变更日期', width: 'auto' },
          { field: 'changin_time', title: '变更时间', width: 'auto' },
          { field: 'sys_approve', title: '审批系统', width: 'auto' },
          { field: 'oper_status_kt', title: '当前操作状态', width: 'auto' }
        ],
        data: []
      }
    }
  },
  created() {
    // 材料计划单据类型
    this.getSelectDictDataOrigin('A0012')
    // 材料计划单据状态
    this.getSelectDictDataOrigin('A0013')
    this.getSelectDictDataOrigin('A0009')
    // 是否选项
    this.getSelectDictDataOrigin('B0099')
    this.handleQueryByCode()
  },
  mounted() {
  },

  methods: {
    // 文件下载
    downLoadFile(row) {
      sapDownloadFile(row.xcontent, row.filename)
    },
    cellClassName({ column }) {
      return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--default'
    },
    // 根据id查询材料计划信息
    async handleQueryByCode() {
      this.loading = true
      try {
        const res = await apiGetMaterialPlanDetail({ iv_packpl_id: this.conditions.packpl_id, user_bp: this.role.USER_BP })
        Object.assign(this.conditions, res.head)
        this.gridOptions.data = res.item
        this.gridOptionsFile.data = res.attachment
        this.gridOptionsHistory.data = res.history
        if (res.button.edit) {
          this.formDis = true
        }
      } catch (error) {
        //
      }
      this.loading = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/material-plan-manage/components/highenMaterialPLanCheck.vue